/**
 * 业务基础代码v2
 * 改进代码结构，去除部分重复和非必须代码
 *
 * @author mingxin.huang
 * @update 2014.11.1
 *
 * 公用方法
 *
 * debug          : 调试方法,
 * getRoot        : 获取文件或者api的绝对路径,
 * loadScriptCss  : 加载css和js文件,
 * isIE6          : 判断是否为IE6,
 * isMobile       : 判断是否是手机,
 * isFlashEnabled : 判断是否支持flash,
 * getResult      : 获取数据接口
 * isNewLive      : 判断是否跳转新直播间
 */

$.module('MM.core', function () {
  var _isRelease = 'release' == MM.config.mode && !IS_LOCAL;
  var _enableDebug = $.query.get('debug') || false; //用于正式服开启调试模式

  /**
   * 调试方法
   */
  function _debug() {
    if (_isRelease && !_enableDebug) {
      return;
    }

    if (window.console) {
      if (typeof console.log == 'function' && console.log.apply) {
        console.log.apply(console, arguments);
      } else {
        switch (arguments.length) {
          case 1:
            console.log(arguments[0]);
            break;
          case 2:
            console.log(arguments[0], arguments[1]);
            break;
          case 3:
            console.log(arguments[0], arguments[1], arguments[2]);
            break;
          case 4:
            console.log(arguments[0], arguments[1], arguments[2], arguments[3]);
            break;
          default:
            break;
        }
      }
    }
  }

  window.debug = _debug;

  /**
   * 判断是否是手机
   * @return {Boolean} [description]
   */
  function _isMobile() {
    var ua = navigator.userAgent;

    if (
      ua.match(/Android/i) ||
      ua.match(/webOS/i) ||
      ua.match(/iPhone/i) ||
      ua.match(/iPod/i) ||
      ua.match(/BlackBerry/i) ||
      ua.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 判断是否是ipad
   * @return {Boolean} [description]
   */
  function _isIpad() {
    return /iPad/g.test(navigator.userAgent);
  }

  /**
   * 判断是否支持flash
   * @return {Boolean} [description]
   */
  function _isFlashEnabled() {
    var hasFlash = false;
    try {
      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (fo) hasFlash = true;
    } catch (e) {
      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined)
        hasFlash = true;
    }
    return hasFlash;
  }

  // 用来配置接口前缀
  var MODE_PREFIX = {
    local: 'dev',
    dev: 'dev',
    test: 'test',
    grey: 'grey',
  };

  /**
   * 获取文件或者api的绝对路径
   * @param  {String} url  文件或者api的相对路径
   * @param  {String} type 路径类型（api, base, app...）参考MM.config.domain
   * @param  {String} protocol 使用的协议类型（http/https/site）默认使用https，site则表示和网站协议相同
   * @return {String}      返回一个绝对路径的地址
   */
  function _getRoot(url, type, protocol) {
    if (url.indexOf('http') === 0) {
      return url;
    }

    type = type || 'api';

    var siteProtocol = 'https'; //location.protocol.slice(0, -1);
    var domainType = type || 'api';
    var domain = MM.config.domain[domainType];
    var baseRoot = type === 'base' ? 'base/' : '';

    protocol = 'https'; //protocol === 'site' ? siteProtocol : (protocol || 'https');

    if (siteProtocol === 'https') {
      var httpsDomain = _.get(MM.config, 'domain.https.' + domainType);

      domain = httpsDomain || domain;
    }

    if (domain) {
      var origin = /http/.test(domain) ? domain : protocol + '://' + domain;

      return origin + (url[0] === '/' ? '' : '/') + baseRoot + url;
    } else {
      var prefix = MODE_PREFIX[MM.config.mode];
      var origin =
        protocol +
        '://' +
        (prefix ? prefix + '-' : '') +
        type +
        '.memeyule.com';

      return origin + (url[0] === '/' ? url : '/' + url);
    }
  }

  var _commbo =
    (MM.config.isRelease() || MM.config.isGrey()) && !IS_LOCAL ? '/??' : '';
  var _baseRoot = _getRoot('scripts' + _commbo, 'base');
  var _appScriptRoot = _getRoot('static' + _commbo, 'app');
  var _appStyleRoot = _getRoot('styles', 'app');

  /**
   * 加载js文件
   * @param  {Array}   urlAry   路径的数组
   * @param  {Function} callback 回调函数
   */
  function _loadScript(urlAry, callback) {
    var deferreds = [];

    $.ajaxSetup({ cache: true, crossDomain: true });

    for (var i = 0, l = urlAry.length; i < l; i++) {
      deferreds.push($.getScript(urlAry[i]));
    }

    $.when.apply(null, deferreds).then(function (data, status, jqXHR) {
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  /**
   * 加载CSS文件
   * @param  {Array}   cssAry   css文件数组
   */
  function _loadCss(cssAry) {
    // IE使用原生方法
    if ($.browser.msie && document.createStyleSheet) {
      for (var i = 0, l = cssAry.length; i < l; i++) {
        document.createStyleSheet(cssAry[i]);
      }
    } else {
      for (var i = 0, l = cssAry.length; i < l; i++) {
        $('head').append('<link href="' + cssAry[i] + '" rel="stylesheet">');
      }
    }
  }

  var APP_REG = /(https?:)?\/\/app.sumeme.com\/2339\/www-v2\/static/; //用来匹配正式上js路径的正则
  /**
   * 重新组织需要加载的文件数组，如果需要拼接则对文件进行拼接处理
   * @param  {Array}  ary     文件数组
   * @param  {String}  root   根目录
   * @param  {Boolean} isCombo 是否需要拼接
   * @return {Array}          一个处理好的数组
   */
  function _organizeFileAry(ary, root, isCombo) {
    if (!ary || ary.length === 0) {
      return [];
    }

    var tempAry = [],
      tempStr = '';
    if (isCombo && _commbo) {
      tempStr = root;
      for (var i = 0, l = ary.length; i < l; i++) {
        var tmpUrl = ary[i];
        tmpUrl = tmpUrl.replace(APP_REG, '');
        tempStr += tmpUrl + (i === l - 1 ? '' : ',');
      }

      tempAry.push(tempStr);
    } else {
      for (var i = 0, l = ary.length; i < l; i++) {
        var tmpUrl = ary[i];

        if (/http(s)?:/.test(tmpUrl)) {
          tmpUrl = tmpUrl;
        } else if (root === _baseRoot) {
          tmpUrl = root + tmpUrl;
        }

        tempAry.push(tmpUrl);
      }
    }

    return tempAry;
  }

  /**
   * 加载css和js文件
   * @param  {Object}   data     js和css文件集合
   * {
   * 	baseStyles : [],
   * 	baseScripts : [],
   * 	appStyles : [],
   * 	appScripts : []
   *  isCombo : Boolean
   * }
   * @param  {Function} callback 加载完成的回调函数
   */
  function _loadScriptCss(data, callback) {
    _debug('%cload scripts & styles ：%o', 'font-weight:bold;', data);

    var baseStylesAry = _organizeFileAry(data.baseStyles, _baseRoot, true);
    var baseScriptsAry = _organizeFileAry(data.baseScripts, _baseRoot, true);
    var appStylesAry = _organizeFileAry(data.appStyles, _appStyleRoot, false);

    var appScriptsAry = [];
    var appScripts = data.appScripts;
    var isCombo = _.isBoolean(data.isCombo) ? data.isCombo : true;
    if (_.isArray(appScripts)) {
      appScriptsAry = _organizeFileAry(
        data.appScripts,
        _appScriptRoot,
        isCombo && appScripts.length > 1,
      );
    } else {
      for (var key in appScripts) {
        var currRoot = _appScriptRoot;
        var currScripts = appScripts[key];

        if (key !== '/static' && _commbo) {
          currRoot = _appScriptRoot.replace('/static', key);
          currScripts = _.map(currScripts, function (value) {
            return value.replace('//' + (MM.config.domain.app || '') + key, '');
          });
        }

        appScriptsAry = appScriptsAry.concat(
          _organizeFileAry(currScripts, currRoot, isCombo),
        );
      }
    }

    _loadCss(baseStylesAry);
    _loadCss(appStylesAry);
    _loadScript(baseScriptsAry.concat(appScriptsAry), callback);
  }

  /**
   * 判断当前的请求是否为跨域请求
   * @param  {String}  url url地址
   * @return {Boolean}     是否跨域
   */
  function _isCrossDomain(url) {
    //初始化全局参数-是否跨域的
    var mainRoot = $.query.parseURL();
    var dataRoot = $.query.parseURL(url);
    return !(mainRoot.host == dataRoot.host && mainRoot.port == dataRoot.port);
  }
  /**
   * @return {Boolean} 是否IE
   */
  function _isIE() {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      return true;
    } else {
      return false;
    }
  }
  function _isSafari() {
    var UserAgent = navigator.userAgent.toLowerCase();
    return /safari/.test(UserAgent) && !/chrome/.test(UserAgent);
  }
  /**
   * 判断是否为IE6
   * @return {Boolean} 是否IE6
   */
  function _isIE6() {
    return $.browser.msie && $.browser.version === '6.0';
  }

  function _isIE7() {
    return $.browser.msie && $.browser.version === '7.0';
  }

  function _isIE8() {
    return $.browser.msie && $.browser.version === '8.0';
  }

  function _isIE9() {
    return $.browser.msie && $.browser.version === '9.0';
  }

  /**
   * 是否为低版本的IE
   */
  function isLowVersionIE() {
    return _isIE6() || _isIE7() || _isIE8();
  }

  function _getResult(options) {
    options.error = options.resolveError || options.error;

    return request.send(options);
  }

  function getServerTime(callback) {
    return request.get('public/t_hex', function (res) {
      callback && callback(parseInt(res.data, 16));
    });
  }

  function isDebugEnable() {
    return _enableDebug;
  }

  return {
    debug: _debug,
    getRoot: _getRoot,
    loadScriptCss: _loadScriptCss,
    isIE6: _isIE6,
    isIE7: _isIE7,
    isIE8: _isIE8,
    isIE9: _isIE9,
    isMobile: _isMobile,
    isIpad: _isIpad,
    isFlashEnabled: _isFlashEnabled,
    getResult: _getResult,
    isIE: _isIE,
    isSafari: _isSafari,
    getServerTime: getServerTime,
    isDebugEnable: isDebugEnable,
    isLowVersionIE: isLowVersionIE,
  };
});
